import React from "react";
import ElitePopup from "ComponentsUI/ElitePopup";
import classNames from "classnames";
import { LazyImage } from "react-lazy-images";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";

export default class ProviderItemBasis extends React.Component {
	static defaultProps = {
		onProviderSelect: () => {},
		onProviderConnect: () => {},
	};

	providerConnect(e) {
		!!this.props.onProviderConnect && this.props.onProviderConnect(this.props.data);
	}

	generateCommonPart() {
		let text = this.props.text;
		return (
			<React.Fragment>
				{this.props.data.vip_provider == 1 && (
					<ElitePopup flat={this.props.flat} text1={text.ELITE_TEXT_1} text2={text.ELITE_TEXT_2} />
				)}
			</React.Fragment>
		);
	}

	preventRedirect(e) {
		if (!this.props.data.reviews_info.count_total) {
			e.preventDefault();
		}
	}

	generateButton() {
		const text = this.props.text;
		let classes = this.props.classes;

		return (
			<div onClick={(e) => this.preventActions(e)} className={classNames(classes.buttons)}>
				<div
					className={classes.buttonsItem}
					data-test="providers_provider_connect_button"
					onClick={(e) => this.providerConnect(e)}
				>
					<span className={classes.buttonsItemText}>{text.CHECK_COVERAGE}</span>
				</div>
			</div>
		);
	}

	preventActions(e) {
		e.preventDefault();
		e.stopPropagation();
	}

	preventPropagation(e) {
		e.stopPropagation();
		let siteCode = this.props.siteCode;
		if (siteCode === "101internet" && !!this.props.catalogProviders) {
			Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.CLICK_PROVIDER, []);
		}
	}

	generateLogo(item) {
		let classes = this.props.classes;
		return React.cloneElement(this.props.linkComponent, {
			to: this.props.generateProviderUrl(item),
			className: classes.logoWrapper,
			onClick: (e) => this.preventPropagation(e),
			children: (
				<LazyImage
					src={
						!!this.props.webpTransformer
							? this.props.webpTransformer(this.props.generateLogoPath(item))
							: this.props.generateLogoPath(item)
					}
					alt={item.name}
					placeholder={({ imageProps, ref }) => <img ref={ref} />}
					actual={({ imageProps }) => <img {...imageProps} className={classes.logo} />}
				/>
			),
		});
	}
}
